import React from 'react';
import PropTypes from 'prop-types';
import { percentFormat } from '../../Utils/NumberFormatting';
import City from './City';
import { Title, Link } from './styles';

const emptyMeta = {
	count: 0
};

export default class Count extends React.PureComponent {
	render() {
		return <>
			<Title>
				<strong>Komunální volby</strong>
				<span>
					Sečteno celkem: {percentFormat(this.props.meta.count)}
				</span>
			</Title>
			{this.props.meta.count < 100 && <div>
				{this.props.cities.map(city => (
					<City
						key={city.id}
						id={city.id}
						name={city.name}
						meta={this.props.cityData[city.id] || emptyMeta}
						linkToMunicipal={this.props.linkToMunicipal}
					/>
				))}
			</div>}
			<Link>
				<a href={this.props.linkToMunicipal}>Souhrnné výsledky</a>
			</Link>
		</>
	}
}

Count.propTypes = {
	meta: PropTypes.shape({
		count: PropTypes.number.isRequired
	}).isRequired,
	cities: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		name: PropTypes.string.isRequired
	})).isRequired,
	cityData: PropTypes.object.isRequired,
	linkToMunicipal: PropTypes.string.isRequired
}
